// 新版本弹窗
<template>
  <div class="newPopup">
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      width="660px"
      :lock-scroll="false"
      :modal-append-to-body="false"
    >
      <div class="newPopup_diaog" @click="onclose"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
    };
  },
  created() {},
  computed: {},
  methods: {
    onshow() {
      this.dialogVisible = true;
    },
    onclose() {
      this.dialogVisible = false;
      this.putNewVersion()
    },
    putNewVersion() {
      this.$api.putNewVersion()

    },
  },
};
</script>

<style scoped lang="scss">
.newPopup {
  ::v-deep .el-dialog {
    background-color: rgba($color: #000000, $alpha: 0);
    box-shadow: none;
    margin-top: 0px !important;

    &__header {
      padding: 0;
    }

    &__body {
      padding: 0;
      background-color: rgba($color: #000000, $alpha: 0);
    }
  }

  &_diaog {
    // margin-top: calc((100vh - 565px) / 3);
    margin-top: 50px;
    background-image: url(~@/assets/image/newPopup.webp);
    width: 660px;
    height: 662px;
    background-size: 660px 662px;
    background-repeat: no-repeat;
    position: relative;
  }
}
</style>
